import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Layout from "../layouts/Layout";
import Parser from 'html-react-parser';

const PrivacyPolicy = () => {
  const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, []);
  useEffect(() => {
    document.title = "Ultimate Organic Life - Privacy Policy";
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const [privacyPolicy, setPrivacyPolicy] = useState();
  useEffect(() => {
    axios.get("privacy-policy")
      .then(resp => {
        // console.log(resp.data.description);
        setPrivacyPolicy(resp.data.description);
      });
  }, []);

  return (
    <div>
      {loading && (
                <div className="loader-container">
                    <div className="spinner"></div>
                </div>
            )}
      <Layout>
      <div className="page-header breadcrumb-wrap">
          <div className="breadcrumb">
            <Link to="/" itemProp="item" title="Home">
              Home
            </Link>
            <span></span> Privacy Policy
            <span></span>
          </div>
        </div>
        <br/>
        <div className="row justify-content-center">
          <div className="col-12 pt-1 pb-4">
          {privacyPolicy && (
            Parser(privacyPolicy)
            )}
          </div>
        </div>

      </Layout>
    </div>
  );
};

export default PrivacyPolicy;
